import React from "react";
import PriceListPage from "./pages/PriceListPage";
import SelectOptions from "./pages/KickStartYourBusiness/SelectOptions";
import SelectOptions2 from "./pages/KickStartYourBusiness/SelectOptions2/SelectOptions2";
import StartPage from "./pages/KickStartYourBusiness/StartPage/StartPage";

const routesArr = [
  {
    index: true,
    element: <PriceListPage/>
  },
  {
    path: '/pricelist',
    element: <PriceListPage/>
  },
  {
    path: '/ksyb/selectOptions',
    element: <SelectOptions/>
  },
  {
    path: '/ksyb/startPage',
    element: <StartPage/>
  }
];

export default routesArr;
